export const masks: any = {
  unmask: (str: string): string => str.replace(/[^a-zA-Z0-9]/g, ''),
  number: (str: string): string => str.replace(/\D/g, ''),
  state: (str: string): string => str.replace(/\d/, ''),
  hour: (str: string): string =>
    str
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d{1,2})/, '$1:$2') // Adiciona o separador :
      .replace(/(:\d{2}).*/, '$1') // Limita a entrada a HH:MM
      .slice(0, 5),
  showHour: (str: string): string => {
    str = str.toString()
    return str.length === 3
      ? str.replace(/(\d{1})(\d)/, '$1h$2')
      : str.replace(/(\d{2})(\d)/, '$1h$2')
  },
  cpf: (str: string = ""): string =>
    str
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1'),
  rg: (str: string): string =>
    str
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{1})\d+?$/, '$1'),
  cnpj: (str: string): string =>
    str
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1'),
  document: (str: string): string => {
    const cleaned = str.replace(/\D/g, '')
    if (cleaned.length <= 11) {
      return cleaned
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1')
    }
    return cleaned
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  },
  zipcode: (str: string): string =>
    str
      .replace(/\D/g, '')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{3})\d+?$/, '$1'),
  phone: (str: string): string =>
    str
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{5})\d+?$/, '$1'),
  cell: (str: string): string =>
    str
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1'),
  username: (str: string = ''): string => str.replace(/[^a-zA-Z0-9-]+/g, '').replace(/\s+/g, '-'),
  currency: (value: string = ''): string => {
    value = String(value).replace(/\D/g, '')
    const numericValue = parseInt(value.replace(/\D/g, ''), 10) || 0
    return (numericValue / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
    })
  },
  currencyAllPlatforms: (value: number | string): string => {
    if (typeof value === 'number') {
      const [currency, cents] = (value / 100).toFixed(2).split('.')
      return `R$ ${currency.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${cents}`
    }
    const numericValue = parseInt(value.replace(/\D/g, ''), 10) || 0
    const [currency, cents] = (numericValue / 100).toFixed(2).split('.')
    return `R$ ${currency.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${cents}`
  },
  percentage: (str: string): string => {
    const number = Math.min(Number(str.replace(/\D/g, '')), 100)
    return `${number}`
  },
  time: (str: string): string => {
    let cleaned = str.replace(/\D/g, '').substring(0, 4)
    cleaned = cleaned.replace(/(\d{2})(\d{2})/, '$1:$2')
    const parts = cleaned.split(':')
    let hours = parseInt(parts[0], 10)
    let minutes = parseInt(parts[1], 10)
    hours = Number.isNaN(hours) ? 0 : Math.min(Math.max(hours, 0), 23)
    minutes = Number.isNaN(minutes) ? 0 : Math.min(Math.max(minutes, 0), 59)

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
  },
  creditCard: (value: string): string =>
    value
      .replace(/\D/g, '')
      .replace(/(\d{4})(\d)/, '$1 $2')
      .replace(/(\d{4})(\d)/, '$1 $2')
      .replace(/(\d{4})(\d)/, '$1 $2')
      .replace(/(.\d{4})\d+?$/, '$1'),
  creditCardDate: (value: string): string => {
    const cleaned = value.replace(/\D/g, '')
    const formatted = cleaned.replace(/(\d{2})(\d{2})/, '$1/$2')
    const [month, year] = formatted.split('/')
    const validMonth = Math.min(parseInt(month, 10), 12).toString().padStart(2, '0')
    return `${validMonth}/${year}`
  },
  cvv: (value: string): string => value.replace(/[^\d]/g, '').substring(0, 4),
}
